import React from 'react';
import {Input} from "./Input";

export class Textarea extends Input {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <label>{this.props.label}{this.props.required ? '*' : ''}</label>
                {this.props.helpText && (
                    <small className="form-text text-muted mb-1">{this.props.helpText}</small>
                )}
                <textarea className={this.getClassName()} type={this.props.type} value={this.state.value}
                          name={this.props.name} id={this.props.name} placeholder={this.props.placeholder}
                          onChange={this.handleChange} required={this.props.required} disabled={this.props.disabled}/>
                <div className="invalid-feedback">
                    <ul className="errors">
                        {this.hasError() ? this.state.errors.map((error, index) => {
                            return <li key={index + 1}>{error}</li>
                        }) : ''}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}